import { InjectionToken } from '@angular/core';

export interface RedirectionTrackingServiceConfig {
  trackRedirectFromCookieModal: (stepSlug: string) => void;
  trackOpenModal: (stepSlug: string) => void;
  trackCloseModal: (stepSlug: string) => void;
  trackExternalRedirect: (stepSlug: string) => void;
  trackKnowMore: (stepSlug: string) => void;
  knowMoreUnderstood: (stepSlug: string) => void;
  trackKnowMoreClose: (stepSlug: string) => void;
  trackKnowMoreCgu: (stepSlug: string) => void;
  trackAlreadyClient: (partnerLabel: string) => void;
  trackShowOtherPartners: () => void;
  trackBforBankCloseWithoutResponse: (stepSlug: string) => void;
  trackBforBankConsentAccepted: (stepSlug: string) => void;
  trackBforBankConsentDeclined: (stepSlug: string) => void;
  trackBforBankConsentModalClosed: (stepSlug: string) => void;
  trackBforBankConsentFromModal: (stepSlug: string, hasConsented: boolean) => void;
  trackBforBankCookieModalClickCta: (stepSlug: string) => void;
  trackBforBankExternalRedirect: (stepSlug: string) => void;
  trackConditionsClick: () => void;
  trackRedirect: (partnerId: string) => void;
}

export const REDIRECTION_TRACKING_SERVICE_CONFIG = new InjectionToken<RedirectionTrackingServiceConfig>(
  'REDIRECTION_TRACKING_SERVICE_CONFIG'
);
